/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Clubhouse Reservation Request Schema
 * @export
 * @interface CreateClubhouseReservationRequestRequest
 */
export interface CreateClubhouseReservationRequestRequest {
    /**
     * Begin Date
     * @type {Date}
     * @memberof CreateClubhouseReservationRequestRequest
     */
    beginDate: Date;
    /**
     * End Date
     * @type {Date}
     * @memberof CreateClubhouseReservationRequestRequest
     */
    endDate: Date;
    /**
     * Notes
     * @type {string}
     * @memberof CreateClubhouseReservationRequestRequest
     */
    notes: string;
}

/**
 * Check if a given object implements the CreateClubhouseReservationRequestRequest interface.
 */
export function instanceOfCreateClubhouseReservationRequestRequest(value: object): value is CreateClubhouseReservationRequestRequest {
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function CreateClubhouseReservationRequestRequestFromJSON(json: any): CreateClubhouseReservationRequestRequest {
    return CreateClubhouseReservationRequestRequestFromJSONTyped(json, false);
}

export function CreateClubhouseReservationRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClubhouseReservationRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'beginDate': (new Date(json['begin_date'])),
        'endDate': (new Date(json['end_date'])),
        'notes': json['notes'],
    };
}

export function CreateClubhouseReservationRequestRequestToJSON(value?: CreateClubhouseReservationRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'begin_date': ((value['beginDate']).toISOString()),
        'end_date': ((value['endDate']).toISOString()),
        'notes': value['notes'],
    };
}

